var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(i,n){return _c('FooterSocialItem',_vm._b({key:n},'FooterSocialItem',i,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }